export { WindowsAuthenticationProvider } from './windowsAuthenticationProvider';